<template>
  <div class="showcase-banner">
    <span class="banner__icon">⚠️</span>
    <span class="banner__text">
      <strong>Showcase-Modus:</strong> Dies ist eine Demo-Umgebung. Daten werden nicht gespeichert oder übermittelt.
    </span>
  </div>
</template>

<script>
export default { name: 'ShowcaseBanner' };
</script>

<style scoped>
.showcase-banner {
  background: #fef3c7;
  border-bottom: 1px solid #fde68a;
  padding: 9px 24px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #78350f;
  width: 100%;
  flex-shrink: 0;
}
.banner__icon { font-size: 15px; }
</style>
